export {
  default,
  BasicDetailsFormDefaultValues,
  type IBasicDetailsForm,
} from "./basicDetails";
